import { logExceptionIntoSentry } from 'venn-utils';
import { compact } from 'lodash';
import React from 'react';
import { addTagV3, removeTagV3 } from 'venn-api';

export type TagableItem = {
  fundId?: string;
  portfolioId?: number;
};

export const addTagToItems = async (tag: string, items: TagableItem[]) => {
  try {
    await addTagV3({
      tag,
      entities: {
        fundIds: compact(items.map((item) => item.fundId)),
        portfolioIds: compact(items.map((item) => item.portfolioId)),
      },
    });
  } catch (e) {
    // @ts-expect-error fixme: ts errors from upgrade to typescript 5.5.3
    logExceptionIntoSentry(e);
  }
};

export const removeTagFromItems = async (tag: string, items: TagableItem[]) => {
  try {
    await removeTagV3({
      tag,
      entities: {
        fundIds: compact(items.map((item) => item.fundId)),
        portfolioIds: compact(items.map((item) => item.portfolioId)),
      },
    });
  } catch (e) {
    // @ts-expect-error fixme: ts errors from upgrade to typescript 5.5.3
    logExceptionIntoSentry(e);
  }
};

export const getTagsTooltip = (tagSet: Set<string>, placeHolder?: React.ReactNode) => {
  const tags = [...tagSet.values()];
  return tags.length ? (
    <div className="text-left min-w-[100px]">
      <div className="text-[12px]">Tags ({tags.length}):</div>
      <div className="text-[14px]">
        {tags.length === 1 ? tags[0] : tags.map((t, idx) => (idx === tags.length - 1 ? `& ${t}` : `${t}, `))}
      </div>
    </div>
  ) : (
    placeHolder
  );
};
